module.exports = __webpack_public_path__ + "fd6d8c78f6c64a07af0420d069556cea.jpg";